<template>
  <div class="cursor-pointer z-10 flex group relative">
    <Link
      :href="href"
      class="flex items-center justify-center border-b w-16 h-12 border-gray-900 px-2 py-4 lg:px-4 focus:bg-blue-600 hover:bg-blue-700 group-hover:bg-blue-600"
    >
      <slot name="icon">
        <icons name="link"></icons>
      </slot>
      <div class="rounded-br absolute inset-x-full top-0 hidden group-hover:flex w-48 flex-wrap">
        <div class="bg-blue-600 h-12 w-48 border-b border-gray-900 rounded-r px-2 py-4 lg:px-4">
          <slot></slot>
        </div>
      </div>
    </Link>
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3';
export default {
  props: ['href'],
  components: { Link },
};
</script>
